// extracted by mini-css-extract-plugin
export default {"button":"Sl-z","reviewSort":"Tl-z"};